<template>
  <img
    src="icons/magnet.svg"
    alt="Hedge Rose Flower SVG"
    :width="width"
    :height="height"
    ref="magnet"
    data-scroll
    data-scroll-sticky
    data-scroll-target="#magnet-container-carousel"
    class="fixed z-0 transition-all animate-bounce-slow ease-in duration-1000 will-change-magnet"
    :class="position.display"
    :style="`left: ${position.x}px; top: ${position.y}px; opacity: ${position.opacity};`"/>
</template>
<script>
  import { defineComponent } from '@vue/composition-api';
  import SvgImage from '~/components/General/SvgImage.vue';

  export default defineComponent({
    name: 'CursorMagnet',
    components: {
      SvgImage
    },
    props: {
      field: {
        type: String,
        default: 'document.body'
      },
      icon: {
        type: String,
        default: ''
      },
      width: {
        type: String,
        default: '0'
      },
      height: {
        type: String,
        default: '0'
      }
    },
    data() {
      return {
        position: {
          x: 0, y: 0, opacity: '0', transform: 'scale(0)', display: 'none'
        },
      }
    },
    mounted() {
      const field = document.querySelector(this.field);
      field.addEventListener("mouseenter", (event) => this.toggleMagnet(event));
      field.addEventListener("mouseover", (event) => this.toggleMagnet(event));
      field.addEventListener("mouseout", (event) => this.hideMagnet(event));
      field.addEventListener("touchend", (event) => this.hideMagnet(event));
    },
    methods: {
      toggleMagnet(event) {
        requestAnimationFrame(() => {
          this.position = {
            x: event.clientX + 15,
            y: event.clientY + 15,
            opacity: 1,
            display: 'block'
          }
        })
      },
      hideMagnet(event) {
        requestAnimationFrame(() => {
          this.position = {
            x: event.clientX,
            y: event.clientY,
            opacity: 0,
            display: 'none'
          }
        })
      }
    }
  })
</script>
